import styled from 'styled-components';
import { Link } from 'gatsby';
import { media } from '../../utils/media';

import { COLORS_SETS, FOOTER_TEXT_COLOR } from '../../utils/colors';

export const Content = styled.div`
  width: calc(66% - 80px);
  margin-right: 80px;
  align-self: flex-end;

  * {
    outline: none;
  }
`;

export const Footer = styled.div`
  height: 410px;
  background-color: ${({ category }) => COLORS_SETS[category].link};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.6px;
  color: ${FOOTER_TEXT_COLOR};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 50px 40px;
  margin-top: 150px;

  ${media.desktop`
    padding: 40px 80px;
  `}

  @media print {
    display: none;
  }
`;

export const FooterContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  ${media.desktop`
    flex-grow: unset;
    margin-top: 0;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  `}
`;

export const FooterSectionWrapper = styled.div`
  display: flex;
  text-transform: uppercase;
  line-height: 1.33em;
`;

export const FooterSectionName = styled.div``;

export const FooterSectionNumber = styled.div`
  margin-left: 12px;
  font-weight: normal;
`;

export const FooterTitle = styled.div`
  font-size: 42px;
  font-weight: 300;
  letter-spacing: -0.24px;
  flex: 1;
  width: 100%;

  ${media.desktop`
    font-size: 48px;
  `}
`;

export const FooterLink = styled(Link)`
  text-decoration: none;
  line-height: 1.17em;
  text-transform: uppercase;
  color: ${FOOTER_TEXT_COLOR};
  flex: 0 auto;

  &:after {
    content: '>';
    display: inline-block;
    margin-left: 5px;
    line-height: 1em;
    position: relative;
    top: -1px;
  }
`;
